<mat-toolbar color="primary" style="height: 60px;">
    <div>
      <button mat-icon-button (click)="openSidenav()">
        <mat-icon>menu</mat-icon>
      </button>
    </div>
  
    
    <img class="logo" src="../../../assets/images/logo.png" height="48"/>
</mat-toolbar>